<template>
    <div>
        <v-card style="min-height:300px">
            <v-toolbar flat color="info" height="50" >
                <v-toolbar-title>
                    Healthmark Item Picker
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon color="primary" @click.prevent="onPicked()">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>

            <v-card-text>
                <v-form ref="frmItemSearch" v-model="formValid" lazy-validation>
                    <v-layout>
                        <v-flex xs12 sm6>
                            <v-text-field
                                ref="txtItemNo"
                                v-model="keyword" 
                                label="Enter Partial Item # or Name to search"
                                :hint="keywordFieldHint"
                                persistent-hint
                                :autofocus=true
                                @focus="selectAllText"
                                ></v-text-field>
                        </v-flex>
                        <v-flex xs12 offset-sm1 sm5 >
                            <v-checkbox
                            v-model="hasRecentSaleOnly"
                            label="Search Items Having Recent Sales Orders Only"
                            color="success"
                            style="padding-top: 0px;margin-top:0"
                            ></v-checkbox>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-card-text>
            <v-card-text v-show="entries.length">
                <!-- <v-layout row v-if="error">
                    <v-flex xs12>
                        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
                    </v-flex>
                </v-layout>      -->
                <h3>Please Pick below:</h3>
                <v-data-table
                    :items="entries"
                    item-key="id"
                    :pagination.sync="pagination"
                    :rows-per-page-items="pagination.rowsPerPageItems"
                    disable-initial-sort
                    hide-headers
                >
                    <template slot="items" slot-scope="props">
                    <tr>
                        <td style="padding:1px;margin:1px">
                            <v-btn large @click.prevent="onPicked(props.item)" class="primary" style="padding:0px;margin:0px">
                                Pick
                            </v-btn>
                            
                        </td>
                        <td>
                            <v-img
                                :src="props.item.imgThumbnailUrl"
                                height="100"
                                width="100"
                                contain
                            ></v-img>
                            <v-layout>
                                <v-flex text-xs-center>
                                    <v-icon medium v-show="props.item.sellingRank=='NEW'">fiber_new</v-icon>
                                </v-flex>
                            </v-layout>
                            <v-rating
                            v-model="props.item.sellingRankNum"
                            color="yellow darken-3"
                            background-color="grey darken-1"
                            empty-icon="$vuetify.icons.ratingFull"
                            half-increments
                            hover
                            small
                            :dense="true"
                            :readonly="true"
                            ></v-rating>
                        </td>
                        <td class="text-xs-left">
                            <div class="body-2">
                                {{ props.item.itemNumber }}
                            </div>
                            <div>
                                {{ props.item.description }}
                            </div>
                        </td>
                        <!-- <td class="text-xs-right">{{ props.item.totalMainSalesAmt? props.item.totalMainSalesAmt : 'n/a' | currency}}</td>
                        <td class="text-xs-right">{{ props.item.totalMainCommiAmt? props.item.totalMainCommiAmt : 'n/a' | currency}}</td>
                        <td class="text-xs-right">{{ props.item.totalMainPercent? props.item.totalMainPercent : '' }}</td>
                        <td class="text-xs-right">{{ props.item.createDate }}</td>
                        <td class="text-xs-right">{{ props.item.createBy }}</td> -->
                    </tr>
                    </template>
                </v-data-table>  
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import _ from "lodash"
import { mapActions } from 'vuex'

export default {
    props: ['resetKeyword'],
    data () {
        return {
            formValid : false,
            keyword : '',
            hasRecentSaleOnly: true,
            minCharsToSearch : 3,
            rules: {
                required: v => !! v || 'This field is required'
            },
            entries: [],
            pagination: {
                descending: true,
                page: 1,
                rowsPerPage: 10,
                sortBy: '',
                totalItems: 0,
                rowsPerPageItems: [10, 20, 50]
            },
            headers: [
                // {text: 'Acct. #', value: 'code'},
                // {text: 'Facility / Customer Name', value: 'description'},
                // {text: 'Address', value: 'address'},
                // {text: 'Main Sales Amt.', value: 'totalMainSalesAmt'},
                // {text: 'Main Commi. Amt.', value: 'totalMainCommiAmt'},
                // {text: 'Percent', value: 'totalMainCommiAmt'},
                // {text: 'Create', value: 'createDate'},
                // {text: 'By', value: 'createBy'}
            ],
        }
    },
    computed: {
        keywordFieldHint () {
            return `Need at least ${this.minCharsToSearch} characters to start search`
        },
    },
    methods: {
        ...mapActions('itemSearch',[
            'searchItemByNumber'
        ]),
        selectAllText(event) {
            event.target.select();
        },
        onPicked(itemPicked) {
            this.$emit('onItemPicked', itemPicked)
            // reset data
            // this.keyword = ''
            // this.entries = []
        },
        resetSearch(itemPicked) {
            // reset data
            this.keyword = ''
            this.entries = []
        },
        searchItems: _.debounce(async function (val) {
                    // if (this.searchCriteria.statusSelected === null || this.searchCriteria.statusSelected.length === 0) {
                    //     alert('Please select at least one status to search')
                    //     return
                    // }
                    // const jtSelected = this.searchCriteria.jobTypeSelected === 0
                    //     ? this.jobTypes.map(item => item.id)
                    //     : [this.searchCriteria.jobTypeSelected]
                    // const payload = Object.assign({}, this.searchCriteria, { jobTypeSelected: jtSelected })
                    // this.$store.dispatch('jobSearch/searchJobs', payload)
                    //     .then(data => {
                    //         this.jobs = data
                    //         // console.log('jobs' + this.jobs)
                    //     })
            // if(!val || !val.length || val.length < 3)
            //     return
            if(!val || !val.length)
                return
            // this.isLoading = true;

            let FacilitysFound = await this.searchItemByNumber({number: this.keyword, hasRecentSaleOnly: this.hasRecentSaleOnly});
            // let FacilitysFound = await this.searchItemByNumber({number: val, hasRecentSaleOnly: this.hasRecentSaleOnly});
            // console.log(`FacilitysFound: ${FacilitysFound.length}`)
            this.count = FacilitysFound.length
            this.entries = FacilitysFound

            this.$refs.txtItemNo.focus()
            // this.isLoading = false
        }, 1000),
    },
    watch: {
        resetKeyword: function(newVal, oldVal){
            if(this.resetKeyword) {
                this.resetSearch()
            }
        },
        keyword : function(newVal, oldVal) {
            this.searchItems(newVal)
        },
        hasRecentSaleOnly : function(newVal, oldVal) {
            this.searchItems(this.keyword)
        },
    }
}
</script>
